module.exports = "/_next/static/images/27811e03e4faa0f5d34bc93251b43e31-safe.svg.webp";